<nz-alert nzType="info"
          class="mx-4 mt-2 mb-2 d-none d-lg-block"
          [nzMessage]="'Функция в тестовом режиме'"
          nzShowIcon></nz-alert>

<div [formGroup]="leadsService.taskForm">
  <nz-form-item>
    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="auto_message_active">
      Активность
      <i-feather
        nz-tooltip="При необходимости можно деактивировать функцию"
        nzTooltipPlacement="right" nzTooltipColor="#2B85F2" name="helpfull" class="text-primary icon-sm ml-2"
      ></i-feather>
    </nz-form-label>
    <nz-form-control [nzSm]="14" [nzXs]="24">
      <label id="auto_message_active" nz-checkbox formControlName="auto_message_active">Да</label>
    </nz-form-control>
  </nz-form-item>

  <div [formGroup]="leadsService.taskForm">
    <nz-form-item>
      <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="no_create_lead">
        Не создавать лид
        <i-feather
          nz-tooltip="При активной галке будет произведен только ответ, без создания лида"
          nzTooltipPlacement="right" nzTooltipColor="#2B85F2" name="helpfull" class="text-primary icon-sm ml-2"
        ></i-feather>
      </nz-form-label>
      <nz-form-control [nzSm]="14" [nzXs]="24">
        <label id="no_create_lead" nz-checkbox formControlName="no_create_lead">Да</label>
      </nz-form-control>
    </nz-form-item>

  <nz-form-item class="mt-3">
    <nz-form-label [nzSm]="6" [nzXs]="24">
      Отвечать в
      <i-feather
        nz-tooltip="Ответ в чатах сможет отправиться только в те чаты, что указаны в данном задании, а в личные сообщения с любого чата в системе"
        nzTooltipPlacement="right" nzTooltipColor="#2B85F2" name="helpfull" class="text-primary icon-sm ml-2"
      ></i-feather>
    </nz-form-label>
    <nz-form-control [nzSm]="14" [nzXs]="24">
      <nz-radio-group
        formControlName="replay_type"
      >
        <label nz-radio-button nzValue="private">
          <i-feather name="user"></i-feather>
          личные сообщения
        </label>
        <label nz-radio-button nzValue="chat">
          <i-feather name="message-square"></i-feather>
          чат
        </label>
      </nz-radio-group>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="auto_message_is_move_to">
      Перемещать в "обработку"
      <i-feather
        nz-tooltip='Лид будет перенесен в колонку "В обработке"'
        nzTooltipPlacement="right" nzTooltipColor="#2B85F2" name="helpfull" class="text-primary icon-sm ml-2"
      ></i-feather>
    </nz-form-label>
    <nz-form-control [nzSm]="14" [nzXs]="24">
      <label id="auto_message_is_move_to" nz-checkbox formControlName="auto_message_is_move_to">Да</label>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label nzRequired [nzSm]="6" [nzXs]="24" nzFor="auto_message_min_scope">
      Порог срабатывания автоответа
      <i-feather
        nz-tooltip="Если у лида будет процент схожести с вашими примерами более указаного значение, то будет автоматически отпарвелно ему сообщение указанное ниже. Так же будет переслано оригинальное сообщение автора перед вашим автоответом."
        nzTooltipPlacement="right" nzTooltipColor="#2B85F2" name="helpfull" class="text-primary icon-sm ml-2"
      ></i-feather>
    </nz-form-label>
    <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Укажите порог">
      <nz-input-group style="width: min-content;" nzAddOnAfter="%">
        <nz-input-number id="auto_message_min_scope" formControlName="auto_message_min_scope" [nzMin]="50" [nzMax]="100"
                         [nzStep]="0.55"></nz-input-number>
      </nz-input-group>
      <nz-alert *ngIf="leadsService.taskForm.get('auto_message_min_scope').value < 52" class="pt-3" nzType="info"
                nzMessage="Вы указали низкое значение, ваше сообщение может отправиться человеку по сообщению которое не подходит под ваши примеры сообщений."
                nzShowIcon></nz-alert>
    </nz-form-control>
  </nz-form-item>


  <app-message-editor
    [showImprove]="false"
    [Service]="senderService"
    [formControl]="leadsService.taskForm.get('auto_message')"
    [placeholder]="'Напишите тут текст сообщения для автоматической отправки автору сообщения при появлении лида.'"
  ></app-message-editor>

</div>
